import React from 'react'
import { IconButton, SnackbarContent } from '@material-ui/core'
import { Close as CloseIcon, Info as InfoIcon } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'

import { styles } from './styles'

// Once per module: makeStyles called inside a render built a new JSS sheet,
// with new class names, on every render (booking screen, 11 Oct 2026).
const useStyles = makeStyles(styles)

export function SnackbarContentWrapper(props) {
  const classes = useStyles()
  const { className, message, onClose, ...other } = props

  return (
    <SnackbarContent
      className={className}
      message={
        <span id="client-snackbar" className={classes.message}>
          <InfoIcon className={classes.infoIcon} />
          {message}
        </span>
      }
      action={[
        <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      ]}
      {...other}
    />
  )
}
